import { Component, Inject, Input, OnInit } from '@angular/core';
import { ApplicationFacade, Stop } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-bus-stop-header',
    templateUrl: './bus-stop-header.component.html',
    styleUrls: ['./bus-stop-header.component.scss']
})
export class BusStopHeaderComponent implements OnInit {
    @Input() stop: Stop & { distance?: number };
    isContrast$ = this.applicationFacade.highContrast$;

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    ngOnInit(): void {
        if (this.env.WMB && this.stop) {
            this.stop = { ...this.stop, dist: this.stop.dist || this.stop.distance };
        }
    }
}
